import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SystemAreas } from 'src/app/shared/enums/system-areas.enum';
import { PublicProfileManagerComponent } from './components/public-profile-manager/public-profile-manager.component';
import { AnotherProvidersComponent } from './pages/another-providers/another-providers.component';
import { DentalServicesComponent } from './pages/dental-services/dental-services.component';
import { DoctorComponent } from './pages/doctor/doctor.component';
import { HealthBeautyComponent } from './pages/health-beauty/health-beauty.component';
import { HospitalComponent } from './pages/hospital/hospital.component';
import { ImageCenterDiscountsComponent } from './pages/image-center-discounts/image-center-discounts.component';
import { ImageCenterComponent } from './pages/image-center/image-center.component';
import { InsuranceComponent } from './pages/insurance/insurance.component';
import { LaboratoryDiscountsComponent } from './pages/laboratory-discounts/laboratory-discounts.component';
import { LaboratoryComponent } from './pages/laboratory/laboratory.component';
import { OpticsComponent } from './pages/optics/optics.component';
import { PharmacyComponent } from './pages/pharmacy/pharmacy.component';
import { PhysiotherapyComponent } from './pages/physiotherapy/physiotherapy.component';
import { PrimaryCareClinicsComponent } from './pages/primary-care-clinics/primary-care-clinics.component';
import { SuraComponent } from './pages/sura/sura.component';
import { ReschedulePublicProfileComponent } from './components/reschedule-public-profile/reschedule-public-profile.component';
import { NotFoundComponent } from 'src/app/shared/components/not-found/not-found.component';
import { ProfessionalLicenseComponent } from './pages/professional-license/professional-license.component';
import { ClinicHistoryByHashResolver } from '../medical-orders/resolvers/clinic-history-by-hash.resolver';
import { PublicProfileResolver } from './resolvers/public-profile.resolver';

const routes: Routes = [
  {
    path: 'hospital',
    component: HospitalComponent,
    children:[
      {
        path: ':nickname',
        component: PublicProfileManagerComponent,
        data: {
          idAreaSistema: SystemAreas.PERFIL_PUBLICO_HOSPITAL
        },
        resolve: { publicProfile: PublicProfileResolver }
      }
    ]
  },
  {
    path: 'laboratorio',
    component: LaboratoryComponent,
    children:[
      {
        path: ':nickname',
        component: PublicProfileManagerComponent,
        data: {
          idAreaSistema: SystemAreas.PERFIL_PUBLICO_LABORATORIO
        },
        resolve: { publicProfile: PublicProfileResolver }
      }
    ]
  },
  {
    path: 'centro-imagen',
    component: ImageCenterComponent,
    children:[
      {
        path: ':nickname',
        component: PublicProfileManagerComponent,
        data: {
          idAreaSistema: SystemAreas.PERFIL_PUBLICO_CENTRO_IMAGENES
        },
        resolve: { publicProfile: PublicProfileResolver }
      }
    ]
  },
  {
    path: 'farmacia',
    component: PharmacyComponent,
    children:[
      {
        path: ':nickname',
        component: PublicProfileManagerComponent,
        data: {
          idAreaSistema: SystemAreas.PERFIL_PUBLICO_FARMACIA
        },
        resolve: { publicProfile: PublicProfileResolver }
      }
    ]
  },
  {
    path: 'aseguradora',
    component: InsuranceComponent,
    children:[
      {
        path: ':nickname',
        component: PublicProfileManagerComponent,
        data: {
          idAreaSistema: SystemAreas.PERFIL_PUBLICO_ASEGURADORA
        },
        resolve: { publicProfile: PublicProfileResolver }
      }
    ]
  },
  {
    path: 'sede-sura',
    component: SuraComponent,
    children:[
      {
        path: ':nickname',
        component: PublicProfileManagerComponent,
        data: {
          idAreaSistema: SystemAreas.PERFIL_PUBLICO_SEDES_SURA
        },
        resolve: { publicProfile: PublicProfileResolver }
      }
    ]
  },
  {
    path: 'fisioterapia',
    component: PhysiotherapyComponent,
    children:[
      {
        path: ':nickname',
        component: PublicProfileManagerComponent,
        data: {
          idAreaSistema: SystemAreas.PERFIL_PUBLICO_FISIOTERAPIA
        },
        resolve: { publicProfile: PublicProfileResolver }
      }
    ]
  },
  {
    path: 'salud-belleza',
    component: HealthBeautyComponent,
    children:[
      {
        path: ':nickname',
        component: PublicProfileManagerComponent,
        data: {
          idAreaSistema: SystemAreas.PERFIL_PUBLICO_SALUD_Y_BELLEZA
        },
        resolve: { publicProfile: PublicProfileResolver }
      }
    ]
  },
  {
    path: 'servicio-odontologico',
    component: DentalServicesComponent,
    children:[
      {
        path: ':nickname',
        component: PublicProfileManagerComponent,
        data: {
          idAreaSistema: SystemAreas.PERFIL_PUBLICO_SERVICIOS_ODONTOLOGICOS
        },
        resolve: { publicProfile: PublicProfileResolver }
      }
    ]
  },
  {
    path: 'optica',
    component: OpticsComponent,
    children:[
      {
        path: ':nickname',
        component: PublicProfileManagerComponent,
        data: {
          idAreaSistema: SystemAreas.PERFIL_PUBLICO_OPTICAS
        },
        resolve: { publicProfile: PublicProfileResolver }
      }
    ]
  },
  {
    path: 'clinica-atencion-primaria',
    component: PrimaryCareClinicsComponent,
    children:[
      {
        path: ':nickname',
        component: PublicProfileManagerComponent,
        data: {
          idAreaSistema: SystemAreas.PERFIL_PUBLICO_CLINICAS_ATENCION_PRIMARIA
        },
        resolve: { publicProfile: PublicProfileResolver }
      }
    ]
  },
  {
    path: 'otros',
    component: AnotherProvidersComponent,
    children:[
      {
        path: ':nickname',
        component: PublicProfileManagerComponent,
        data: {
          idAreaSistema: SystemAreas.PERFIL_PUBLICO_OTROS_PROVEEDORES
        },
        resolve: { publicProfile: PublicProfileResolver }
      }
    ]
  },
  {
    path: 'laboratorio-con-descuento',
    component: LaboratoryDiscountsComponent,
    children:[
      {
        path: ':nickname',
        component: PublicProfileManagerComponent,
        data: {
          idAreaSistema: SystemAreas.PERFIL_PUBLICO_LABORATORIOS_CON_DESCUENTOS
        },
        resolve: { publicProfile: PublicProfileResolver }
      }
    ]
  },
  {
    path: 'centro-imagen-con-descuento',
    component: ImageCenterDiscountsComponent,
    children:[
      {
        path: ':nickname',
        component: PublicProfileManagerComponent,
        data: {
          idAreaSistema: SystemAreas.PERFIL_PUBLICO_IMAGENOLOGIA_CON_DESCUENTOS
        },
        resolve: { publicProfile: PublicProfileResolver }
      }
    ]
  },
  {
    path: '',
    component: DoctorComponent,
    children:[
      {
        path: ':nickname/licencia/:id',
        component: ProfessionalLicenseComponent,
        data: {
          animation: 'ProfessionalLicensePage'
        },
        resolve: {
          professionalLicense: ClinicHistoryByHashResolver
        }
      },
      {
        path: ':nickname',
        component: PublicProfileManagerComponent,
        data: {
          idAreaSistema: SystemAreas.PERFIL_PUBLICO_DOCTOR,
          animation: 'PublicProfilePage'
        },
        resolve: { publicProfile: PublicProfileResolver }
      },
      {
        path: 'reprogramar/:nickname',
        component: ReschedulePublicProfileComponent,
        data: {
          idAreaSistema: SystemAreas.PERFIL_PUBLICO_DOCTOR,
          animation: 'PublicProfilePage'
        },
      },
      {
        path: '',
        component: NotFoundComponent        
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PublicProfilesRoutingModule { }
